import { unemojify } from 'node-emoji';

/**
 * Функция, которая удаляет сурогатные пары из строки
 * Про сурогатные пары можете почитать тут: https://learn.javascript.ru/unicode#surrogatnye-pary
 */
export const removeSurrogatePair = (str: string): string => {
  let resStr = '';
  // использую iterator, так как это самый короткий и работающий метод для данной задачи
  // eslint-disable-next-line no-restricted-syntax
  for (const char of str) {
    if (char.length !== 2) {
      resStr += char;
    }
  }
  return resStr;
};

/**
 * Функция, которая заменяет смайлики на текстовый аналог и удаляет все остальные сурагатные пары
 * На всякий случай обернул в try catch дабы избежать неожиданностей с библиотекой
 */
export const removeSurrogatePairAndReplaceEmojiToText = (
  str: string,
): string => {
  try {
    // преобразовываем смайлики в текст
    const changeSmileStr = unemojify(str);
    return removeSurrogatePair(changeSmileStr);
  } catch (err) {
    return removeSurrogatePair(str);
  }
};
